import { render } from "./ChankangOperate.vue?vue&type=template&id=37e2e679&ts=true"
import script from "./ChankangOperate.vue?vue&type=script&lang=ts"
export * from "./ChankangOperate.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__